import React from 'react';
import { Field } from 'formik';
import { Box } from 'lmc-ui-library';
import { FIELDS, FIELDS_LABELS, RADIO_VALUES } from '../types';
import { StatusProps } from './types';

import styles from '../profile.module.scss';

interface Props {
  label: string;
}

const DDStatus: React.FC<StatusProps & Props> = ({ label, data, onChangeClick }) => {
  const lmcChangeHandler = (event: any) => {
    const lmcHandler = onChangeClick('lmc_is_active');
    const boolValue = event.target.value === RADIO_VALUES.ACTIVE;
    lmcHandler(boolValue);
  };

  return (
    <Box title="Status" className={styles.box}>
      <Box.Content>
        <div className={styles.inlineContainer}>
          <label className={styles.label}>{label}:</label>
          <p className={styles.DDstatus}>{data.dueDiligenceStatus}</p>
        </div>

        <label className={styles.label}>{FIELDS_LABELS.BP_STATUS}:</label>
        <div
          className={styles.radioContainer}
          role="group"
          aria-labelledby={FIELDS_LABELS.LMC_STATUS}
          onChange={lmcChangeHandler}>
          <label>
            <Field type="radio" name={FIELDS.LMC_STATUS} value={RADIO_VALUES.ACTIVE} className={styles.radioBtn} />
            <span className={styles.customRadio} />
            Active
          </label>
          <label>
            <Field type="radio" name={FIELDS.LMC_STATUS} value={RADIO_VALUES.INACTIVE} className={styles.radioBtn} />
            <span className={styles.customRadio} />
            Disabled
          </label>
        </div>
      </Box.Content>
    </Box>
  );
};

export default DDStatus;
